import { Component, OnInit } from '@angular/core';
import {PageAction} from '../../components/page-actions/page-actions.component';
import {Router} from '@angular/router';
import {DataTableEvent} from '../../components/data-table/data-table.component';
import {TranslationService} from '@services/translation/translation.service';

@Component({
    selector: 'app-translation',
    templateUrl: './translation.component.html',
    styleUrls: ['./translation.component.scss'],
    providers: [TranslationService],
    standalone: false
})
export class TranslationComponent implements OnInit {
  public title = 'Translation';
  public translations;
  public translationsKey;
  public columns = [{prop: 'language', name: 'Language'}];
  public pageActions: PageAction[];
  public currentPage = { title: '', type: '' };

  constructor(public translationService: TranslationService, private router: Router) { }

  ngOnInit(): void {
    this.translationService.find(0, 100, {}).then(result => {
      const translationsTemp = {};
      if (result.data && result.data.length) {
        for (let i = 0; i < result.data.length; i++) {
          if (!translationsTemp.hasOwnProperty(result.data[i].type)) {
            translationsTemp[result.data[i].type] = [];
          }
          translationsTemp[result.data[i].type].push(result.data[i]);
        }
      }
      this.translations = translationsTemp;
      this.translationsKey = Object.keys(this.translations);
    });
    this.createPageActions();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['translation/', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['translation', event.row._id, 'edit']);
  }

  tabChange($event) {
    this.currentPage = this.translations[$event.index];
  }

  private createPageActions(): void {
    this.pageActions = [new PageAction({ icon: 'add', translationString: 'translation.create', callback: () => { this.router.navigate(['translation/create']) } } as any)];
  }

}
